module.exports = __webpack_public_path__ + "static/media/1.b0a33904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/1.png
// module id = 1721
// module chunks = 0